exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tooltip {\n  position: absolute;\n  overflow: hidden;\n  pointer-events: none;\n  transition: opacity 1s;\n}[dir] .custom-tooltip {\n  -webkit-transition: opacity 1s;\n}\n\n.custom-tooltip.ag-tooltip-hiding {\n  opacity: 0;\n}\n\n.custom-tooltip p {\n  white-space: nowrap;\n}\n\n[dir] .custom-tooltip p {\n  margin: 5px;\n}\n\n.custom-tooltip p:first-of-type {\n  font-weight: bold;\n}\n", ""]);

// exports
